import { staticContentRoutes } from './static/static-content-routes'
import { customTopicRoutes } from './topic/custom-topic-routes'

import { homepage } from './home'
import { regionalRoutes } from './regionals'
import { westlive } from './west-live'
import { StaticRoutes } from '@news-mono/web-common'
import { TheWestSection } from '@news-mono/component-library'
import { getYourStoryOurStoryRouteInfo } from './features/your-story-our-story'
import { getLisaGovanRouteInfo } from './features/lisa-govan'
import { getNewsletterSubscriptionRouteInfo } from './newsletter-subscription/newsletter-subscription'
import { getBlakDeathsInCustodyRouteInfo } from './features/blak-deaths-in-custody'
import { getGenesisRouteInfo } from './features/genesis-ballet'

export const staticRoutes: StaticRoutes<TheWestSection> = {
    ...staticContentRoutes,
    ...customTopicRoutes,
    ...homepage,
    ...regionalRoutes,
    ...westlive,
    ...getYourStoryOurStoryRouteInfo,
    ...getLisaGovanRouteInfo,
    ...getNewsletterSubscriptionRouteInfo,
    ...getBlakDeathsInCustodyRouteInfo,
    ...getGenesisRouteInfo,
}
